module.exports = __webpack_public_path__ + "static/media/middle-east-bg-mobile.da712da1.png";